import { useSelector } from "react-redux";
import { WritingTipsWrapper, TipsTitle, TipsWrapper, ListWrapper, WrapperElement, ListWrapperContent } from "../../atoms/Menu";
import writeWhat from "../../../images/writeWhat.svg";
import askWhat from "../../../images/askWhat.svg";
import AvoidWhat from "../../../images/Topics_to_avoid.svg";
import { Modal } from "react-bootstrap";
import { AddChildCloseIcon, TemplateHeading, Templateiconstylehead, Templatetextstylehead, } from "../../atoms/ConnectStories";
import { useTranslation } from "react-i18next";
import photoGuidelines from "../../../images/Photo_guidelines.svg";
import TipsIcon from "../../../images/Tips_Icon.svg";
import DOMPurify from "dompurify";
import "../../../styles/ConnectScreen.css";
function TipsForWriting(props) {
    const { loginReducer } = useSelector((state) => state);
    const tipsForWriting = loginReducer?.getSOConfiguration?.tipsForWriting;
    const { t } = useTranslation();

    return ( 
        <Modal
            className="tips-popup"
            show={props?.isVisible}
            dialogClassName="custom-modal-width vertical-custom-modal"
             >
        <AddChildCloseIcon  onClick={props?.setVisibility}>X</AddChildCloseIcon>
        <TemplateHeading>
                <Templateiconstylehead>
                    <img src={TipsIcon} alt="" />
                </Templateiconstylehead>
                <Templatetextstylehead>{t("TipsForWriting")}</Templatetextstylehead>
        </TemplateHeading>
        <WritingTipsWrapper>
            {tipsForWriting?.map((item,index) => {
                    return(
                        <div key={item.id} style={{width:"100%"}}>
                            
                            <TipsWrapper index={index}>
                                <WrapperElement>
                                    <img src={item.id==1 ? writeWhat : (item.id==2 ? askWhat : (item.id==3 ? AvoidWhat : (item.id==4 ? photoGuidelines : "")))} alt="img"/>
                                </WrapperElement>
                                <ListWrapper>
                                    <TipsTitle>{item?.title}</TipsTitle>
                                    <ListWrapperContent dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(item?.description)}}/>
                                </ListWrapper>
                                
                            </TipsWrapper>
                        </div>)
                })}
        </WritingTipsWrapper>
        </Modal> )
}

export default TipsForWriting;